import { AuthState, SettingsState } from '@/types/state'
import * as getterTypes from '@/store/getter-types'
import * as mutationTypes from '@/store/mutation-types'
import * as actionTypes from '@/store/action-types'

import { UserCredentialsPayload } from '@/types/payload'
import { CurrentUser } from '@/model/CurrentUser'

import axios from '@/plugins/axios'
import { SettingsItem } from '@/model/SettingsItem'

const state: SettingsState = {
  settings: []
}

const getters = {
  [getterTypes.SETTINGS_ALL] (state: SettingsState): SettingsItem[] {
    return state.settings
  }
}

const mutations = {
  [mutationTypes.SETTINGS_REPLACE] (state: SettingsState, payload: SettingsItem[]) {
    state.settings = payload
  }
}

const actions = {}

const settingsModule = {
  state,
  getters,
  mutations,
  actions
}

export default settingsModule
